<template>
  <div style="color: white;">
    <h1>Signing in with Facebook...</h1>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './firebaseConfig.js'

export default {
  name: 'FacebookAuth',
  data() {
    return {
      PARENT_FRAME: document.location.ancestorOrigins[0],
      auth: null
    }
  },
  created() {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }
    this.auth = firebase.auth();
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    sendResponse(result) {
      window.parent.postMessage(JSON.stringify(result), this.PARENT_FRAME);
    },
    handleMessage({ data }) {
      if (data.initAuth) {
        const provider = new firebase.auth.FacebookAuthProvider();
        this.auth.signInWithPopup(provider)
          .then(this.sendResponse)
          .catch(this.sendResponse);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// facebook.vue?83fc0482